import { render, staticRenderFns } from "./SendCoupons.vue?vue&type=template&id=51386adc&scoped=true&"
import script from "./SendCoupons.vue?vue&type=script&lang=js&"
export * from "./SendCoupons.vue?vue&type=script&lang=js&"
import style0 from "./SendCoupons.vue?vue&type=style&index=0&id=51386adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51386adc",
  null
  
)

export default component.exports